import home from "../assets/home.jpg";

import lespetitschanteursdecharlesbourg from "../assets/artists/2025/lespetitschanteursdecharlesbourg.jpeg";
import mathieu_blain from "../assets/artists/2025/mathieu_blain.jpeg";
import philippebournival_yveslussier from "../assets/artists/2025/philippebournival_yveslussier.jpeg";

import { useEffect, useMemo, useState } from "react";
import PageTitle from "../components/PageTitle";
import ConcertCard from "../components/home/ConcertCard";
import ProgramModal from "../components/modals/ProgramModal";

function Home() {
	const [activeConcert, setActiveConcert] = useState(null);

	const concerts = useMemo(
		() => [
			{
				date: new Date(2025, 5, 1),
				artist: "Les Petits Chanteurs de Charlesbourg",
				secondaryArtist: "et Dominique Gagnon",
				img: lespetitschanteursdecharlesbourg,
				program: [],
				// program: [
				// 	{
				// 		title: "Praeludium en sol mineur, BuxWV 148",
				// 		author: "Dietrich Buxtehude (1637-1707)",
				// 	},
				// 	{
				// 		title: "Hommage à Dietrich Buxtehude, Toccata et fugue",
				// 		author: "Petr Eben (1929-2007)",
				// 		items: [
				// 			"I-Con enfasi, ma più Allergro che Buxtehude",
				// 			"II-Ben ritmico",
				// 			"III-Scherzando",
				// 			"IV-Tempo I",
				// 		],
				// 	},
				// 	{
				// 		title: "Toccata no 1, 2e Livre",
				// 		author: "Girolamo Frescobaldi (1583-1637)",
				// 	},
				// 	{
				// 		title: "Hommage à Frescobaldi",
				// 		author: "Jean Langlais (1907-1991)",
				// 		items: [
				// 			"I-Prélude au Kyrie",
				// 			"VII-Thème et Variations",
				// 			"V-Fantaisie",
				// 		],
				// 	},
				// 	{
				// 		title: "Pièces de Fantaisie, suite no 3, opus 54",
				// 		author: "Louis Vierne (1870-1937)",
				// 		items: ["Impromptu"],
				// 	},
				// 	{
				// 		title: "Six Études chorales",
				// 		author: "Thierry Escaich (né en 1965)",
				// 		items: ["Étude no 4 « O Haupt voll Blut und Wunden »"],
				// 	},
				// 	{
				// 		title: "Toccata et fugue en mi majeur, BWV 566",
				// 		author: "Johann Sebastian Bach (1685-1750)",
				// 	},
				// ],
			},
			{
				date: new Date(2025, 5, 8),
				artist: "Mathieu Blain",
				secondaryArtist: "",
				img: mathieu_blain,
				program: [],
			},
			{
				date: new Date(2025, 5, 15),
				artist: "Philippe Bournival, organiste",
				secondaryArtist: "et Yves Lussier, trompettiste",
				img: philippebournival_yveslussier,
				program: [],
			},
		],
		[]
	);

	useEffect(() => {
		const todayConcert = concerts.find(
			(concert) =>
				concert.date.getDate() === new Date().getDate() &&
				concert.date.getMonth() === new Date().getMonth()
		);

		setActiveConcert(todayConcert ?? null);
	}, [concerts]);

	return (
		<div className="text-center">
			<img
				src={home}
				alt="organ"
				className="object-contain w-full mt-8 shadow-xl rounded"
			/>

			<PageTitle title="23e édition | 2025" className="!mt-10 !mb-4" />
			<h2 className="text-xl mb-10 font-semibold">
				Tous nos concerts sont présentés gratuitement à{" "}
				<span className="font-bold italic">15 h</span> en l'église de
				Sainte-Marie !
			</h2>

			<div className="grid grid-cols-1 lg:grid-cols-3 gap-3 lg:gap-8 mb-10">
				{concerts.map((concert, index) => (
					<ConcertCard concert={concert} key={index} />
				))}
			</div>

			<ProgramModal
				concert={activeConcert}
				clear={() => setActiveConcert(null)}
			/>
		</div>
	);
}

export default Home;
